import R from 'ramda'

const OPT_OUT_ACTION_TYPE = 'OPT_OUT'
const OPT_OUT_DISPLAY_TYPE = 'Opt user out'

const isOptOutFormAction = R.propEq('type', OPT_OUT_DISPLAY_TYPE)

const convertOptOutFormActionToWidgetAction = R.applySpec({
  type: R.always(OPT_OUT_ACTION_TYPE)
})

export { isOptOutFormAction, convertOptOutFormActionToWidgetAction }



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/actions/twitter/form-to-widget/opt-out.js